<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="">
            <div class="pt-3">
                <vue-progress-bar></vue-progress-bar>
                <div class="loader" v-if="loading"></div>
                <div v-if="optimoRouteResult.length>0" class="optimoroute-error alert alert-info" role="alert">
                    <strong> OptimoRoute result: </strong> <br/>
                    <div v-for="value in optimoRouteResult">
                        <span>Trip Id #T-{{ value.id }}:</span> <span> {{ value.result }}</span> <br/>
                    </div>
                </div>
                <form @submit.prevent="sendToOptimoRoute">
                    <div class="position-relative pagination-control">
                        <data-table
                            :url="tableUrl"
                            :filters="filters"
                            :columns="columns"
                            :columns_task_status="columns_task_status"
                            :columns_all_status="columns_all_status"
                            :columns_awaiting_date="columns_awaiting_date"
                            :columns_linehaul="columns_linehaul"
                            :per-page="perPage"
                            :translate="translate"
                            :classes="classes"
                            :order-by="orderBy"
                            :order-dir="orderDir"
                            :meta="columns.meta"
                            @loading="reloadTable"
                            :debounce-delay=1000
                            ref="table"
                        >
                            <div slot="filters" slot-scope="{ tableFilters, perPage, trips }">
                                <div class="row my-3">
                                    <div class="col-md-8">
                                        <div class="h2">Trips</div>
                                    </div>
                                    <div class="col-md-2">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <date-picker v-model="filters.dateFrom"
                                                         valueType="YYYY-MM-DD"
                                                         input-class="border-0 py-0 shadow-none form-input"
                                                         placeholder="from"
                                                         :lang="datePickerOptions.lang"
                                                         format="DD/MM/YYYY">
                                            </date-picker>
                                        </div>
                                    </div>

                                    <div class="col-md-2">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <date-picker v-model="filters.dateTo"
                                                         valueType="YYYY-MM-DD"
                                                         input-class="border-0 py-0 shadow-none form-input"
                                                         placeholder="to"
                                                         :lang="datePickerOptions.lang"
                                                         format="DD/MM/YYYY">
                                            </date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="row my-3 d-flex justify-content-end align-items-center">
                                    <div class="col-md-2">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                                <span class="material-icons-outlined cursor-pointer">search</span>
                                            </button>
                                            <input name="name" v-model="filters.search"
                                                   class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                                   placeholder="Search"/>
                                        </div>
                                    </div>

                                    <div class="col-md-7">
                                        <div class="btn-group float-right shadow-sm" role="group" aria-label="">
                                            <button @click="isActive(10)" type="button"
                                                    class="btn border-left px-3 py-2"
                                                    :class="filters.status===10? 'btn-primary':'bg-white'">All
                                            </button>

                                            <button @click="isActive(88)" type="button"
                                                    class="btn border-left px-3 py-2"
                                                    :class="filters.status===88? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Tasks
                                                       <span v-if="counter[88]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==88? 'badge-light':'badge-primary'">
                                                            {{ counter[88] }}
                                                       </span>
                                                </span>
                                            </button>

                                            <button @click="isActive(9)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===9? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Awaiting goods
                                                       <span v-if="counter[0]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==9? 'badge-light':'badge-primary'">
                                                            {{ counter[0] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(11)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===11? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Foreign
                                                       <span v-if="counter[11]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==11? 'badge-light':'badge-primary'">
                                                            {{ counter[11] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(1)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===1? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">New
                                                       <span v-if="counter[1]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==1? 'badge-light':'badge-primary'">
                                                            {{ counter[1] }}
                                                       </span>
                                                     </span>
                                            </button>


                                            <button @click="isActive(2)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===2? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Transferred
                                                       <span v-if="counter[2]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==2? 'badge-light':'badge-primary'">
                                                            {{ counter[2] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(3)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===3? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Scheduled
                                                       <span v-if="counter[3]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==3? 'badge-light':'badge-primary'">
                                                            {{ counter[3] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(7)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===7? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Done
                                                       <span v-if="counter[7]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==7? 'badge-light':'badge-primary'">
                                                            {{ counter[7] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(99)" type="button"
                                                    class="btn border-left px-3 py-2"
                                                    :class="filters.status===99? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Linehaul
                                                       <span v-if="counter[99]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==99? 'badge-light':'badge-primary'">
                                                            {{ counter[99] }}
                                                       </span>
                                                     </span>
                                            </button>

                                            <button @click="isActive(5)" type="button" class="btn border-left px-3 py-2"
                                                    :class="filters.status===5? 'btn-primary':'bg-white'">
                                                <span class="position-relative pr-2">Failed
                                                       <span v-if="counter[5]>0"
                                                             class="badge rounded-circle position-absolute number-quote"
                                                             :class="filters.status==5? 'badge-light':'badge-primary'">
                                                            {{ counter[5] }}
                                                       </span>
                                                     </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-1 additional-filters">
                                        <select
                                            v-model="filters.zip"
                                            class="form-control">
                                            <option value>All</option>
                                            <option value='1'>Sjælland</option>
                                            <option value='2'>Jylland</option>
                                        </select>
                                    </div>

                                    <div class="col-md-1 additional-filters">
                                        <select
                                            v-model="filters.driver"
                                            class="form-control">
                                            <option value>All</option>
                                            <option v-for="driver in drivers.drivers" :value="driver.id">
                                                {{ driver.name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-1 additional-filters">
                                        <small>
                                            <label class="font-weight-bold">Weight </label>
                                            {{ parseFloat(dimensions.weight).toFixed(2).toString().replace('.', ",") }}
                                            <small> kg </small> <br/>
                                            <label class="font-weight-bold">Volume </label>
                                            {{ parseFloat(dimensions.volume).toFixed(2).toString().replace('.', ",") }}
                                            <small> m3 </small><br/>
                                        </small>
                                    </div>
                                </div>
                                <br/>
                            </div>
                            <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                            <tr>
                                <th><input type="checkbox" v-model="allSelected" @change="selectAll($event)"/></th>

                                <th @click="sort(column.id)" v-if="column.label!=='' && filters.status==88"
                                    v-for="column in columns_task_status">
                                    <span> {{ column.label }} </span>
                                </th>

                                <th @click="sort(column.id)" v-if="column.label!=='' && filters.status==10"
                                    v-for="column in columns_all_status">
                                    <span> {{ column.label }} </span>
                                </th>

                                <th @click="sort(column.id)" v-if="column.label!=='' && filters.status==9"
                                    v-for="column in columns_awaiting_date">
                                    <span> {{ column.label }} </span>
                                </th>

                                <th @click="sort(column.id)" v-if="column.label!=='' && filters.status==99"
                                    v-for="column in columns_linehaul">
                                    <span> {{ column.label }} </span>
                                </th>

                                <th @click="sort(column.id)"
                                    v-if="column.label!=='' && filters.status!=10 && filters.status!=88 && filters.status!=9 && filters.status!=99"
                                    v-for="column in columns">
                                    <span> {{ column.label }} </span>
                                </th>

                            </tr>
                            </thead>
                            <tbody ref="tripsTable" slot="body" slot-scope="{ data }">
                            <tr v-if='filters.status==9'
                                :class="trip.markAsColliReceived === true ? 'mark-as-colli-received' : '' "
                                :key="trip.id"
                                v-for="(trip,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns_awaiting_date"
                                    v-bind:class="[trip.status!=='Failed' ? 'laravel-vue-datatable-td' : 'error-row']"
                                >
                                    <data-table-cell
                                        :value="trip"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <div>
                                            <input type="checkbox"
                                                   v-on:change="onTripChecked($event)"
                                                   :value="trip.id"
                                                   v-model="trips[trip.id]"
                                            >
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Trip'">
                                        <a :href="`/trips/${trip.id}/edit`">#{{ trip.optimoroute_id }} - {{
                                                filters.status == 99 ? trip.booking.dropoff_address.name : trip.address.name
                                            }} </a>
                                        <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Client'">
                                        {{ trip.client.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Booking'">
                                        <a :href="`/bookings/${trip.booking_id}/edit`">{{
                                                trip.booking_status_human
                                            }} </a> <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        <div v-if="trip.type === 'Linehaul'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">local_shipping</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Drop-off'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">house</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Pick-up'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">business</span>
                                        </div>
                                        <div v-else>{{ trip.type }}</div>
                                    </slot>

                                    <slot v-if="column.label === 'Address'">
                                        {{
                                            filters.status == 99 ? `${trip.booking.dropoff_address.name},
                                        ${trip.booking.dropoff_address.street}, ${trip.booking.dropoff_address.zip},
                                        ${trip.booking.dropoff_address.city}` : trip.address_data
                                        }}
                                    </slot>


                                    <slot v-if="column.label === 'Services'">
                                        <div class="d-flex">
                                            <div v-for="service in trip.services">
                                                <div v-if="service === 'Indbæring'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">stairs
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indbæring + montering'"><span
                                                    :title="service"
                                                    class="material-icons-outlined cursor-pointer mr-1">build</span>
                                                </div>
                                                <div v-else-if="service === 'Bortskaffelse'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">delete
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indpakning af returvarer'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">archive
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Emballage med retur'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">
                                                        assignment_return
                                                    </div>
                                                </div>
                                                <div v-else>{{ service }}</div>
                                            </div>
                                        </div>
                                    </slot>
                                    <slot v-if="column.label === 'InternalComment'">

                                    </slot>
                                    <slot v-if="column.label === 'Comment'">
                                        {{ trip.internal_comment }}
                                    </slot>


                                    <slot v-if="column.label === 'Volume'">
                                        {{ trip.volume }}m2
                                    </slot>

                                    <slot v-if="column.label === 'Weight'">
                                        {{ trip.weight }}kg
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/trips/${trip.id}/edit`" title="Edit Trip">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            <tr v-if='filters.status==88'
                                :key="trip.id"
                                v-for="(trip,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns_task_status"
                                    v-bind:class="[trip.status!=='Failed' ? 'laravel-vue-datatable-td' : 'error-row']"
                                >
                                    <data-table-cell
                                        :value="trip"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <div>
                                            <input type="checkbox"
                                                   v-on:change="onTripChecked($event)"
                                                   :value="trip.id"
                                                   v-model="trips[trip.id]"
                                            >
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Trip'">
                                        <a :href="`/trips/${trip.id}/edit`">#{{ trip.optimoroute_id }} - {{
                                                filters.status == 99 ? trip.booking.dropoff_address.name : trip.address.name
                                            }} </a>
                                        <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Client'">
                                        {{ trip.client.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Booking'">
                                        <a :href="`/bookings/${trip.booking_id}/edit`">{{
                                                trip.booking_status_human
                                            }} </a> <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        <div v-if="trip.type === 'Linehaul'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">local_shipping</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Drop-off'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">house</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Pick-up'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">business</span>
                                        </div>
                                        <div v-else>{{ trip.type }}</div>
                                    </slot>

                                    <slot v-if="column.label === 'Address'">
                                        {{
                                            filters.status == 99 ? `${trip.booking.dropoff_address.name},
                                        ${trip.booking.dropoff_address.street}, ${trip.booking.dropoff_address.zip},
                                        ${trip.booking.dropoff_address.city}` : trip.address_data
                                        }}
                                    </slot>


                                    <slot v-if="column.label === 'Services'">
                                        <div class="d-flex">
                                            <div v-for="service in trip.services">
                                                <div v-if="service === 'Indbæring'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">stairs
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indbæring + montering'"><span
                                                    :title="service"
                                                    class="material-icons-outlined cursor-pointer mr-1">build</span>
                                                </div>
                                                <div v-else-if="service === 'Bortskaffelse'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">delete
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indpakning af returvarer'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">archive
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Emballage med retur'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">
                                                        assignment_return
                                                    </div>
                                                </div>
                                                <div v-else>{{ service }}</div>
                                            </div>
                                        </div>
                                    </slot>
                                    <slot v-if="column.label === 'InternalComment'">

                                    </slot>
                                    <slot v-if="column.label === 'Comment'">
                                        {{ trip.internal_comment }}
                                    </slot>


                                    <slot v-if="column.label === 'Volume'">
                                        {{ trip.volume }}m2
                                    </slot>

                                    <slot v-if="column.label === 'Weight'">
                                        {{ trip.weight }}kg
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/trips/${trip.id}/edit`" title="Edit Trip">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            <tr v-if='filters.status==10'
                                :key="trip.id"
                                :class="trip.markAsColliReceived === true ? 'mark-as-transferred' : '' "
                                v-for="(trip,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns_all_status"
                                    v-bind:class="[trip.status!=='Failed' ? 'laravel-vue-datatable-td' : 'error-row']"
                                >
                                    <data-table-cell
                                        :value="trip"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <!--                                        <div v-if="trip.type!=='Linehaul' && trip.status_id>0 && trip.tw_start!==null">-->
                                        <div>
                                            <input type="checkbox"
                                                   v-on:change="onTripChecked($event)"
                                                   :value="trip.id"
                                                   v-model="trips[trip.id]"
                                            >
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Trip'">
                                        <a :href="`/trips/${trip.id}/edit`">#{{ trip.optimoroute_id }} - {{
                                                filters.status == 99 ? trip.booking.dropoff_address.name : trip.address.name
                                            }} </a>
                                        <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Client'">
                                        {{ trip.client.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Booking'">
                                        <a :href="`/bookings/${trip.booking_id}/edit`">{{
                                                trip.booking_status_human
                                            }} </a> <br/>

                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        <div v-if="trip.type === 'Linehaul'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">local_shipping</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Drop-off'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">house</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Pick-up'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">business</span>
                                        </div>
                                        <div v-else>{{ trip.type }}</div>
                                    </slot>

                                    <slot v-if="column.label === 'Address'">
                                        {{
                                            filters.status == 99 ? `${trip.booking.dropoff_address.name},
                                        ${trip.booking.dropoff_address.street}, ${trip.booking.dropoff_address.zip},
                                        ${trip.booking.dropoff_address.city}` : trip.address_data
                                        }}
                                    </slot>


                                    <slot v-if="column.label === 'Services'">
                                        <div class="d-flex">
                                            <div v-for="service in trip.services">
                                                <div v-if="service === 'Indbæring'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">stairs
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indbæring + montering'"><span
                                                    :title="service"
                                                    class="material-icons-outlined cursor-pointer mr-1">build</span>
                                                </div>
                                                <div v-else-if="service === 'Bortskaffelse'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">delete
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indpakning af returvarer'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">archive
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Emballage med retur'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">
                                                        assignment_return
                                                    </div>
                                                </div>
                                                <div v-else>{{ service }}</div>
                                            </div>
                                        </div>
                                    </slot>
                                    <slot v-if="column.label === 'InternalComment'">

                                    </slot>
                                    <slot v-if="column.label === 'Comment'">
                                        {{ trip.internal_comment }}
                                    </slot>

                                    <slot v-if="column.label === 'Volume'">
                                        {{ trip.volume }}m2
                                    </slot>

                                    <slot v-if="column.label === 'Weight'">
                                        {{ trip.weight }}kg
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/trips/${trip.id}/edit`" title="Edit Trip">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            <tr v-if='filters.status==99'
                                :class="trip.linehaulRowClass"
                                :key="trip.id"
                                v-for="(trip,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns_linehaul"
                                    v-bind:class="[trip.status!=='Failed' ? 'laravel-vue-datatable-td' : 'error-row']"
                                >
                                    <data-table-cell
                                        :value="trip"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <div>
                                            <input type="checkbox"
                                                   v-on:change="onTripChecked($event)"
                                                   :value="trip.id"
                                                   v-model="trips[trip.id]"
                                            >
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Trip'">
                                        <a :href="`/trips/${trip.id}/edit`">#{{ trip.optimoroute_id }} - {{
                                                filters.status == 99 ? trip.booking.dropoff_address.name : trip.address.name
                                            }} </a>
                                        <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Client'">
                                        {{ trip.client.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Booking'">
                                        <a :href="`/bookings/${trip.booking_id}/edit`">{{
                                                trip.booking_status_human
                                            }} </a> <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        <div v-if="trip.type === 'Linehaul'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">local_shipping</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Drop-off'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">house</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Pick-up'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">business</span>
                                        </div>
                                        <div v-else>{{ trip.type }}</div>
                                    </slot>

                                    <slot v-if="column.label === 'Address'">
                                        {{
                                            filters.status == 99 ? `${trip.booking.dropoff_address.name},
                                        ${trip.booking.dropoff_address.street}, ${trip.booking.dropoff_address.zip},
                                        ${trip.booking.dropoff_address.city}` : trip.address_data
                                        }}
                                    </slot>

                                    <slot v-if="column.label === 'Location'">
                                        <div v-for="location in  trip.location_list">
                                            {{ location }}
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Dropoff'">
                                        {{
                                            (trip.booking.dropoff_start !== null && !trip.booking.dropoff_start.includes('0000-00-00')) ?
                                                trip.booking.dropoff_start :
                                                'Awaiting goods'
                                        }}
                                    </slot>

                                    <slot v-if="column.label === 'Linehaul'">
                                        {{
                                            (trip.tw_start !== null && !trip.tw_start.includes('0000-00-00')) ?
                                                trip.tw_start :
                                                'Awaiting goods'
                                        }}
                                    </slot>

                                    <slot v-if="column.label === 'InternalComment'">

                                    </slot>

                                    <slot v-if="column.label === 'Comment'">
                                        {{ trip.internal_comment }}
                                    </slot>

                                    <slot v-if="column.label === 'Volume'">
                                        {{ trip.volume }}m2
                                    </slot>

                                    <slot v-if="column.label === 'Weight'">
                                        {{ trip.weight }}kg
                                    </slot>


                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/trips/${trip.id}/edit`" title="Edit Trip">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            <tr v-if='filters.status!=88 && filters.status!=10 && filters.status!=9 && filters.status!=99'
                                :class="{
                                    'mark-as-transferred': (filters.status==2 && trip.markAsTransferred === true) ||
                                                           (filters.status==3 && trip.markAsScheduled === true),
                                    'mark-as-foreign-delivery-ready': (trip.status_id==11 && trip.booking.status==7)
                                }"
                                :key="trip.id"
                                v-for="(trip,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns"
                                    v-bind:class="[trip.status!=='Failed' ? 'laravel-vue-datatable-td' : 'error-row']"
                                >
                                    <data-table-cell
                                        :value="trip"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <!--                                        <div v-if="trip.type!=='Linehaul' && trip.status_id>0 && trip.tw_start!==null">-->
                                        <div>
                                            <input type="checkbox"
                                                   v-on:change="onTripChecked($event)"
                                                   :value="trip.id"
                                                   v-model="trips[trip.id]"
                                            >
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Trip'">
                                        <a :href="`/trips/${trip.id}/edit`">#{{ trip.optimoroute_id }} - {{
                                                filters.status == 99 ? trip.booking.dropoff_address.name : trip.address.name
                                            }} </a>
                                        <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Client'">
                                        {{ trip.client.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Booking'">
                                        <a :href="`/bookings/${trip.booking_id}/edit`">{{
                                                trip.booking_status_human
                                            }} </a> <br/>
                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        <div v-if="trip.type === 'Linehaul'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">local_shipping</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Drop-off'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">house</span>
                                        </div>
                                        <div v-else-if="trip.type === 'Pick-up'">
                                            <span :title="trip.type"
                                                  class="material-icons-outlined cursor-pointer mr-1">business</span>
                                        </div>
                                        <div v-else>{{ trip.type }}</div>
                                    </slot>

                                    <slot v-if="column.label === 'Address'">
                                        {{
                                            filters.status == 99 ? `${trip.booking.dropoff_address.name},
                                        ${trip.booking.dropoff_address.street}, ${trip.booking.dropoff_address.zip},
                                        ${trip.booking.dropoff_address.city}` : trip.address_data
                                        }}
                                    </slot>

                                    <slot v-if="column.label === 'Services'">
                                        <div class="d-flex">
                                            <div v-for="service in trip.services">
                                                <div v-if="service === 'Indbæring'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">stairs
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indbæring + montering'"><span
                                                    :title="service"
                                                    class="material-icons-outlined cursor-pointer mr-1">build</span>
                                                </div>
                                                <div v-else-if="service === 'Bortskaffelse'">
                                                    <div :title="service"
                                                         class="material-icons-outlined cursor-pointer mr-1">delete
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Indpakning af returvarer'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">archive
                                                    </div>
                                                </div>
                                                <div v-else-if="service === 'Emballage med retur'">
                                                    <div
                                                        :title="service"
                                                        class="material-icons-outlined cursor-pointer mr-1">
                                                        assignment_return
                                                    </div>
                                                </div>
                                                <div v-else>{{ service }}</div>
                                            </div>
                                        </div>
                                    </slot>

                                    <slot v-if="column.label === 'Comment'">
                                        {{ trip.internal_comment }}
                                    </slot>

                                    <slot v-if="column.label === 'Volume'">
                                        {{ trip.volume }}m2
                                    </slot>

                                    <slot v-if="column.label === 'Weight'">
                                        {{ trip.weight }}kg
                                    </slot>

                                    <slot v-if="column.label === 'Note'">
                                        {{ trip.note }}
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/trips/${trip.id}/edit`" title="Edit Trip">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            </tbody>
                            <div slot="pagination" slot-scope="{ links, meta }"
                                 class="d-flex justify-content-between align-items-center"
                            >
                                <div>
                                    <label class="pr-2">Trips per page:</label>
                                    <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <select class="form-control bg-white border-0 py-0 shadow-none"
                                                v-model="filters.length"
                                                style="width: 150px;">
                                            <option
                                                :key="index"
                                                :value="records"
                                                v-for="(records, index) in perPage">
                                                {{ records }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <pagination
                                    ref="pagination"
                                    :total-pages="meta.last_page"
                                    :current-page-prop="meta.current_page"
                                    v-if="meta && meta.last_page > 1"
                                ></pagination>
                            </div>
                        </data-table>
                    </div>
                    <br/>
                    <button class="btn btn-success"> Send to OptimoRoute</button>
                    <div class="btn btn-info update-orders" v-if="!updateIsInProgress"
                         @click="updateOptimoRouteOrders()"> Update orders
                    </div>
                    <div class="btn btn-info update-orders" v-if="updateIsInProgress"> Update orders</div>
                    <div class="btn btn-primary" @click="exportTrips()"> Export trips</div>
                    <span v-if="showProgressUpdate">
                        <progress-bar
                            :options="progressBarOptions"
                            :value=progressBarValue
                        />
                    </span>
                </form>
            </div>
        </div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script type="text/ecmascript-6">

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import Pagination from "./reusable/Pagination.vue";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";

export default {
    name: "TripDataTable",
    mixins: [datePickerOptionsMixin, dataTablePaginationMixin],
    components: {DatePicker, VueTimepicker, Loading, Pagination},
    props: {
        url: {type: String, required: true},
        counterProp: {type: Object, required: true}
    },
    data() {
        return {
            tableUrl: this.url,
            isLoading: true,
            trips: {},
            currentTrips: [],
            orderBy: 'tw_start',
            orderDir: 'desc',
            search: '',
            perPage: [10, 25, 50, 100],
            loadingOptimoRoute: false,
            optimoRouteResult: [],
            drivers: {},
            showProgressUpdate: false,
            updateIsInProgress: false,
            filters: {
                search: '',
                length: 25,
                status: 1,
                dateFrom: null,
                dateTo: null,
                column: 'tw_start',
                dir: 'desc',
                zip: 0,
                driver: '',
                trips: [],
            },
            loading: false,
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Trip',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Address',
                    //id: 'address',
                    //name: 'address_data',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Time',
                    name: 'time_data',
                    id: 'tw_start',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Services',
                    id: '',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Note',
                    id: 'note',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: '',
                    orderable: false,
                },
            ],
            columns_awaiting_date: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Trip',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Address',
                    id: 'address',
                    // name: 'address_data',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Time',
                    name: 'time_data',
                    id: 'tw_start',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Comment',
                    id: 'internal_comment',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Services',
                    id: '',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: '',
                    orderable: false,
                },
            ],
            columns_task_status: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Trip',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Status',
                    name: 'status',
                    id: 'status',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Address',
                    id: 'address',
                    //name: 'address_data',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Time',
                    name: 'time_data',
                    id: 'tw_start',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Comment',
                    id: 'internal_comment',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Services',
                    id: '',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: '',
                    orderable: false,
                },
            ],
            columns_all_status: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Trip',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Status',
                    name: 'status',
                    id: 'status',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Address',
                    id: 'address',
                    // name: 'address_data',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Time',
                    name: 'time_data',
                    id: 'tw_start',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Services',
                    id: '',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: '',
                    orderable: false,
                },
            ],
            columns_linehaul: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Trip',
                    id: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Client',
                    id: 'client',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Booking',
                    id: 'booking_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Address',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Dropoff',
                    id: 'dropoff',
                    orderable: false,
                    searchable: false,
                },
                {
                    label: 'Linehaul',
                    id: 'linehaul',
                    orderable: false,
                    searchable: false,
                },
                {
                    label: 'Volume',
                    id: 'volume',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Weight',
                    id: 'weight',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Location',
                    id: 'location',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: '',
                    orderable: false,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            progressBarValue: 0,
            progressBarOptions: {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#59A591',
                    backgroundColor: '#6cb2eb',
                    inverted: false
                },
                layout: {
                    height: 35,
                    width: 140,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search for ID'
            },
            selected: [],
            allSelected: false,
            selectedTrips: {},
            counter: this.counterProp,
            dimensions: {'volume': 0, 'weight': 0}
        }
    },
    computed: {
        // linehaulClass() {
        //     console.log(this.tw_start);
        //     if (this.tw_start===null) {
        //         return 'linehaul-yellow-row'
        //     } else {
        //         return 'linehaul-green-row'
        //     }
        // }
    },
    watch: {
        filters: {
            handler: function(newValue) {
                if (this.$refs.pagination) {
                    this.$refs.pagination.changePage('', 1);
                }
            },
            deep: true
        }
    },
    methods: {
        start() {
            this.$Progress.start()
        },
        sort(key) {
            if (key) {
                this.filters.column = key;
                this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
            }
        },
        isActive(value) {
            this.filters.status = value;
        },
        updateOptimoRouteOrders() {
            this.showProgressUpdate = true;
            this.$Progress.start()
            axios.get(`/optimoroute/get-orders/0`).then((response) => {
                setTimeout(
                    setInterval(() => {
                        if (this.progressBarValue < 100) {
                            this.progressBarValue++;
                        } else {
                            this.showProgressUpdate = false;
                        }
                    }, parseInt(response.data.tripsToUpdateCount) * 500 / 100), 2000)
            }).catch((error) => {
            }).finally(() => {
                this.$Progress.finish()
            });
        },
        exportTrips() {
            this.$Progress.start()
            axios({
                url: `/settings/export-trips`,
                method: 'POST',
                responseType: 'arraybuffer',
                data: this.trips
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]), {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `trips.xlsx`);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error)
            }).finally(() => {
                this.$Progress.finish()
            });
        },
        sendToOptimoRoute() {
            //this.$Progress.start()
            this.loading = true;
            axios.post(`/optimoroute/create-order/0/1`, this.trips).then((response) => {
                if (response) {
                    Object.entries(response.data.response).forEach(entry => {
                        const [key, value] = entry;
                        this.optimoRouteResult.push({
                            id: key,
                            result: value.success === true ? 'order successfully created/updated' : 'Error. ' + new Date().toUTCString() + ': ' + value.message,
                            class: value.success === true ? 'success-optimoroute' : 'error-optimoroute'
                        });
                    });
                }
            }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 3000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response);
            }).finally(() => {
                this.loading = false;
                //this.$Progress.finish()
            });
        },
        fetchData() {
            for (let i in this.counter) {
                axios.get(`/trip-statuses-counter`, {params: {tab: i}})
                    .then(({data}) => {
                        this.counter[i] = data;
                    }).catch();
            }
            axios.get(`/trip-drivers/all`)
                .then(({data}) => {
                    this.drivers = data;
                }).catch();
        },
        onTripChecked() {
            this.getDimensionsSum();
        },
        getDimensionsSum() {
            let requestData = {};
            requestData.filters = this.filters;
            requestData.trips = this.trips;
            axios.get('/trip-dimensions-sum', {params: requestData})
                .then(({data}) => {
                    this.dimensions.volume = data.volume;
                    this.dimensions.weight = data.weight;
                }).catch();
        },
        selectAll(event) {
            this.allSelected = event.target.checked;
            if (this.allSelected) {
                this.selectedTrips = {};
                this.trips = {};
                this.$refs.tripsTable.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                    checkbox.checked = true;
                    const tripId = checkbox.value;
                    this.selectedTrips[tripId] = true;
                    this.trips[tripId] = true;
                });
            } else {
                this.selectedTrips = {};
                this.trips = {};
                this.$refs.tripsTable.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                    checkbox.checked = false;
                });
            }
            this.getDimensionsSum();
        },
        reloadTable() {
            this.allSelected = false;
            this.selectedTrips = [];
            this.trips = {};
            this.getDimensionsSum();
        },
    },
    mounted() {
        this.$refs.table.$on("finished-loading", () => {
            this.isLoading = false;
        });

        this.$refs.table.$on("loading", () => {
            this.isLoading = true;
        });
    },
    created() {
        this.filters.status = 1;
        this.fetchData();
    },
}
</script>

<style>
input[type=radio]:checked + label {
    font-style: normal;
    color: rgb(56, 110, 246);
    border: 1px solid rgb(56, 110, 246);
    background-color: rgb(226, 233, 253)
}

.status-checkbox {
    visibility: hidden;
}

.error-row {
    background: #ff00001a;
}

.clickable-header {
    cursor: pointer;
}

.update-orders {
    color: white;
}

.loader {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/../assets/loading_big.gif');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}

.additional-filters {
    margin-bottom: 26px;
}

.mark-as-colli-received {
    background-color: #ff00005e !important;
}


.mark-as-transferred {
    background-color: #ff00005e !important;
}

.mark-as-scheduled {
    background-color: #ff00005e !important;
}

.mark-as-linehauled {
    background-color: #ff00005e !important;
}

.mark-as-foreign-delivery-ready {
    background-color: rgba(0, 255, 144, 0.37) !important;
}
.linehaul-yellow-row {
    background-color: rgba(255, 251, 0, 0.37) !important;
}

.linehaul-red-row {
    background-color: #ff00005e !important;
}

.linehaul-green-row {
    background-color: rgba(0, 255, 144, 0.37) !important;
}

</style>
